/* Upgrade page behaviour.

   Lifted out of sections/zph-upgrade.liquid on 26 Aug 2026. The trigger was
   a misdiagnosis — three pushes had failed to update the section and it
   looked like the size ceiling that moved the CSS out on 17 Aug, but the real
   cause was a `"default": ""` in the schema, which Shopify rejects silently.

   The move is worth keeping anyway. The section was 161KB with this inline
   and is 92KB without it, which is a long way back from a ceiling it really
   did hit once before. The block
   is pure JavaScript — it never contained a Liquid output tag, so it costs
   nothing to serve it as an asset, and everything it needs it reads off
   [data-upg] in the DOM.

   Loaded with `defer`, so it runs after the document is parsed rather than
   mid-parse where it used to sit. Nothing here depends on running earlier:
   it queries the section root itself and bails if it is absent. */
(function () {
  var root = document.querySelector('[data-upg]');
  if (!root) return;
  var sublock = root.getAttribute('data-sublock') === '1';
  var qs = new URLSearchParams(window.location.search);
  /* Every cart and checkout URL below was hardcoded at the site root. That is
     correct today — this store is single-market, Shopify.routes.root is "/" —
     but the day a second market is added Shopify serves this page under a
     locale prefix, and root-absolute /cart/add.js then writes to a different
     market's cart than the one the page was rendered for. Ask Shopify where
     the root is instead of assuming; "/" is the fallback and today's answer. */
  var rootUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var src = qs.get('src') || '';
  if (src) { try { sessionStorage.setItem('zupg_src', src); } catch (e) {} }
  else { try { src = sessionStorage.getItem('zupg_src') || ''; } catch (e) {} }

  function track(ev, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: ev, upg_src: src, upg_tier: root.getAttribute('data-tier') }, data || {}));
      if (window.clarity) window.clarity('set', 'upg_' + ev, (data && data.offer) || '1');
    } catch (e) {}
  }

  function setUnlocked() { root.classList.add('zupg-unlocked'); }

  /* "We found savings for you" points at the cards rather than describing them
     (Aaron, 20 Aug). Delegated off root because the detected-order card is
     rendered conditionally, so the button may not exist when this runs.
     Honours reduced-motion: an instant jump is still a jump. */
  root.addEventListener('click', function (e) {
    var jump = e.target.closest && e.target.closest('[data-jump-kits]');
    if (!jump) return;
    var kits = root.querySelector('#zupg-kits');
    if (!kits) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    kits.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    track('savings_jump', {});
  });


  /* ?src=portal-nosub — the portal's bounce JS vouches there is no ACTIVE,
     PAUSED, or dunning contract on this account. For a detected sub_* tier
     (orders still carry a selling plan after cancellation) that means:
     unlock the checkout path and reframe the banner as a win-back. The param
     is user-typeable; an active subscriber hand-editing the URL is no worse
     off than opening the page logged out, which the anonymous path allows. */
  /* From the URL, not from `src`. `src` falls back to a sessionStorage copy
     that is written on every visit, so deriving the verdict from it let one
     real ?src=portal-nosub bounce leak an unlocked checkout into every later
     view in that tab. Persistence across a reload is zupg_nosub's job, and
     that one is gated on identity and time. */
  var freshNosub = qs.get('src') === 'portal-nosub';
  var nosub = freshNosub;
  /* The bounce can only put the parameter on the URL once, and a reload or a
     second visit in the same session would otherwise re-lock the page and send
     them straight back to the empty portal. Remember the verdict instead.

     The verdict is tied to an IDENTITY, not to the tab. The portal's bounce
     now only says portal-nosub when it saw an authenticated, empty portal
     (anonymous bounces arrive as portal-auth and never reach this code), and
     the flag stores WHICH customer it vouched for. A flag written under one
     identity — or under none, as every pre-fix '1' flag was — is ignored the
     moment the server renders the page for a real customer whose orders say
     otherwise. That is the 24 Aug incident: a cold-session bounce wrote the
     flag, the customer then signed in, and the stale flag overrode a correct
     server-side sublock into a second-subscription checkout.
 */
  var authId = root.getAttribute('data-cid') || '';
  /* Scoped block: this used to be `if (!qaOn)`, guarding the sticky nosub
     flag against QA personas. The harness is gone; the scope stays so the
     locals below keep their own namespace. */
  {
    if (freshNosub && authId === '') {
      /* A nosub bounce with no signed-in customer should no longer be
         possible; if one arrives anyway (hand-typed, old tab), it proves
         nothing — an anonymous portal hides contracts rather than lacking
         them. Do not unlock, do not remember. */
      nosub = false;
    } else if (nosub) {
      /* Identity AND time. The bounce hands over here within seconds, so a
         verdict older than a few minutes is not "this session's portal" any
         more -- it is whatever happened earlier in the tab. 3 Sep 2026: an
         ACTIVE subscriber carried a stale stamp through a fresh Shop sign-in
         and was offered a second-subscription checkout, because the stamp
         had no expiry and nothing on this page ever re-examined it. */
      try { sessionStorage.setItem('zupg_nosub', authId + ':' + Date.now()); } catch (e) {}
    } else if (qs.get('shop_sign_in') === 'true' || qs.get('logged_in') === 'true') {
      /* Arriving back from a sign-in is a fresh look at who this is. Whatever
         the tab believed before the round trip is out of date by definition. */
      try { sessionStorage.removeItem('zupg_nosub'); } catch (e) {}
    } else {
      try {
        var stamp = sessionStorage.getItem('zupg_nosub') || '';
        var sep = stamp.indexOf(':');
        var stampId = sep > -1 ? stamp.slice(0, sep) : stamp;
        var stampAt = sep > -1 ? parseInt(stamp.slice(sep + 1), 10) : 0;   /* bare legacy value = expired */
        var fresh = stampAt > 0 && (Date.now() - stampAt) < 15 * 60 * 1000;
        nosub = authId !== '' && stampId === authId && fresh;
        if (!fresh && stamp) sessionStorage.removeItem('zupg_nosub');
      } catch (e) {}
    }
  }
  if (nosub && sublock) {
    sublock = false;
    root.removeAttribute('data-sublock');
    root.setAttribute('data-path', 'checkout');
    /* The band is not rendered for a detected subscriber any more (the plan
       card says it better), but a win-back still needs this line — it is the
       only thing that tells someone their old plan is closed. Create it if it
       is not there. */
    var det = root.querySelector('[data-detected]');
    if (!det) {
      det = document.createElement('p');
      det.className = 'zupg-found';
      det.setAttribute('data-detected', '');
      var offSec = root.querySelector('.zupg-offers');
      if (offSec) offSec.insertBefore(det, offSec.firstChild);
    }
    if (det) det.innerHTML = 'Welcome back ✓ Your previous plan is closed — pick up right where you left off:';
    track('nosub_unlock');
  }

  /* ---- Gift countdown ----
     Aaron, 23 Aug: make the gift line a limited-time offer.

     Two modes, and the difference matters. `gift_deadline` is a real fixed
     moment, the same for everyone — use it when the campaign genuinely ends.
     Otherwise the timer is a rolling window from this visitor's first view,
     parked in sessionStorage so a reload or a bounce back from the portal does
     not hand them a fresh 15 minutes mid-visit. It does reset on a new session,
     which is what a session timer is; it is urgency, not a deadline, and it is
     one setting away from being an honest one.

     When it runs out the timer does NOT say "expired" and the gifts do not
     stop — the sentence loses its trailing colon and the clock goes, leaving a
     line that is still true. Claiming an offer has ended when it has not is
     worse than not counting at all. */
  (function () {
    var note = root.querySelector('[data-autogift]');
    if (!note) return;
    var clock = note.querySelector('[data-autogift-clock]');
    var txt = note.querySelector('[data-autogift-txt]');
    if (!clock || !txt) return;

    var fixed = (note.getAttribute('data-until') || '').trim();
    var mins = parseFloat(note.getAttribute('data-mins')) || 0;
    var end = null;

    if (fixed) {
      var t = Date.parse(fixed);
      if (!isNaN(t)) end = t;
    } else if (mins > 0) {
      var KEY = 'zupg_gift_until';
      try {
        var saved = parseInt(sessionStorage.getItem(KEY), 10);
        /* Ignore a stored value that is further out than the window allows —
           a stale key from a longer setting would otherwise outlive it. */
        if (saved && saved > Date.now() && saved - Date.now() <= mins * 60000 + 5000) end = saved;
      } catch (e) {}
      if (!end) {
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
      }
    }
    if (!end) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    /* The kit cards show the same countdown. They read this same `end`, never
       their own — two clocks on one page that disagree is worse than no clock,
       and a per-card timer would also restart whenever a card re-rendered. */
    var kitClocks = [].slice.call(root.querySelectorAll('[data-giftclock]'));
    function paintKits(text) {
      kitClocks.forEach(function (el) {
        var t = el.querySelector('[data-giftclock-time]');
        if (t) t.textContent = text;
        el.hidden = false;
      });
    }
    function hideKits() {
      kitClocks.forEach(function (el) { el.hidden = true; });
    }

    function stop() {
      /* The gifts do NOT stop when the clock does, so the urgency line leaves
         rather than announcing an end that has not happened. */
      hideKits();
      clock.hidden = true;
      /* Swap in the finished sentence rather than editing the punctuation of
         the counting one. "...applied at checkout for the next." is not
         English, and deriving a fallback by cutting the string apart breaks the
         moment anyone edits the copy. Two states, two settings. */
      var ended = note.getAttribute('data-ended');
      if (ended) txt.textContent = ended;
    }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { stop(); return; }
      var s = Math.floor(left / 1000);
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var shown = h > 0 ? h + ':' + pad(m) + ':' + pad(sec) : pad(m) + ':' + pad(sec);
      clock.textContent = shown;
      clock.hidden = false;
      paintKits(shown);
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  })();

  /* ---- Land a fresh sign-in on their savings ----
     Signing in is the moment the page stops being a brochure and starts being
     about them, and the proof of that sits well below the fold. Before this,
     a subscriber signed in and was thrown to the Loop portal — which only
     renders its upgrade banner on a single CONTRACT page, so they landed on a
     subscription list with nothing to act on and had to find "View details" to
     be offered anything at all (Aaron, 23 Aug).

     Fires once, only off the flag the sign-in reload sets, or off Shopify's own
     return parameters for the path where Shop establishes the session itself.
     A normal visit to the page is never hijacked. */
  (function () {
    var justIn = false;
    try {
      justIn = sessionStorage.getItem('zupg_justin') === '1';
      if (justIn) sessionStorage.removeItem('zupg_justin');
    } catch (e) {}
    if (!justIn && (qs.get('shop_sign_in') || qs.get('shop_consented_scopes'))) justIn = true;
    if (!justIn || root.getAttribute('data-tier') === 'anon') return;

    var target = root.querySelector('[data-detected]') || root.querySelector('[data-order]')
              || root.querySelector('#zupg-kits');
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Keep trying until it takes. A one-shot scroll silently did nothing,
       because anything modal on the page — the cookie banner, the Shop sign-in
       sheet the customer just used — holds body{overflow:hidden} while it is
       open, and scrollIntoView against a locked body is a no-op that reports
       success. Measured: scrollY stayed 0 with the consent dialog up.

       So: attempt, check the page actually moved, retry, and give up quietly
       after a few seconds rather than fighting a dialog the customer is still
       reading. The first beat is for the reveal animations and the lazy card
       art — scrolling into a half-drawn page looks broken. */
    var deadline = Date.now() + 6000, done = false;
    function tryScroll() {
      if (done) return;
      var before = window.scrollY;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () {
        if (done) return;
        /* Either we moved, or we were already there. */
        if (window.scrollY !== before || Math.abs(target.getBoundingClientRect().top) < 140) {
          done = true;
          track('signin_scroll', { to: target.hasAttribute('data-detected') ? 'found' : 'kits' });
          return;
        }
        if (Date.now() < deadline) tryScroll();
      }, 420);
    }
    setTimeout(tryScroll, 900);
  })();

  /* Which CTA family shows on every card: checkout for everyone except a
     detected (and not nosub-cleared) subscriber, who gets the Loop swap link —
     a selling-plan checkout would mint a second contract. */
  function applyPath() {
    root.querySelectorAll('.zupg-card [data-buy]').forEach(function (buy) {
      buy.classList.toggle('zupg-show', !sublock);
    });
  }

  /* Routing v2: a detected subscriber with a rung to climb is forwarded to
     the portal, where the pinned upgrade campaign performs the real switch
     on their existing contract. Once per session; never after a nosub
     bounce; never inside the theme editor. */
  var fwd = root.getAttribute('data-fwd') === '1';
  var designMode = window.Shopify && window.Shopify.designMode;
  if (sublock && fwd && !nosub && !designMode && root.getAttribute('data-state') === 'offer') {
    var sent = false;
    try { sent = sessionStorage.getItem('zupg_fwd') === '1'; } catch (e) {}
    if (!sent) {
      try { sessionStorage.setItem('zupg_fwd', '1'); } catch (e) {}
      track('portal_forward', { offer: root.getAttribute('data-offer') });
      window.location.replace(root.getAttribute('data-portal') || '/a/loop_subscriptions');
      return;
    }
  }

  /* ---- Checkout hand-off ----
     One-time buyer path: identical to the cart drawer's proven flow —
     clear, add doypack line (with target plan) + tin, stamp attribution
     into cart attributes, go to checkout. No price maths in JS.

     Three things this has to survive, all measured on the draft 24 Aug:

     1. The customer comes BACK. Every browser that has a back/forward cache —
        Safari always, Chrome and Firefox on a page like this one, which sends
        no `no-store` — restores this page from memory rather than reloading
        it, DOM and JS heap intact. So the button we disabled and relabelled on
        the way out is still disabled and still says "Preparing your upgrade…"
        when they return from checkout, and nothing ever runs to put it back:
        the success path deliberately never restores, because it was navigating
        away for good (Aaron, 24 Aug — "it just had the buttons as 'preparing
        your upgrade' and it was stuck and not clickable anymore"). Reproduced
        on every card that has a buy button. `pageshow` with persisted=true is
        the only event that fires on that restore, so that is where the reset
        lives.

     2. They click a SECOND card while the first is still in flight. Disabling
        only the clicked button left its neighbours live, and the two flows
        interleaved as clear, clear, add, add — both adds landing after both
        clears, so the cart went to checkout holding BOTH kits, two tins and
        two sets of gifts. The lock has to be page-wide, not per-button.

     3. Shopify says 429. Cart endpoints are rate limited per IP, and a click
        measured against the live store on 24 Aug got 429 on both
        /cart/clear.js and /cart/add.js and dropped the customer on an alert
        with no way to recover. That particular burst was self-inflicted test
        traffic, but the exposure is not: the budget is per IP, not per
        visitor, so carrier-grade NAT and office networks share it, and this
        page spends four cart calls per session on its own (wetracked stamps
        attribution once on load, then our clear/add/update). Losing a sale to
        one transient 429 is not a trade worth making, so retry with backoff
        before giving up. */
  var busy = false;
  var buyBtns = [].slice.call(root.querySelectorAll('[data-buy]'));
  /* Captured once, up front, rather than at click time: after a bfcache
     restore the live textContent is the "Preparing…" string, so reading it
     then would make the stuck label permanent. */
  buyBtns.forEach(function (b) { b.setAttribute('data-label', b.textContent); });

  function releaseBuys() {
    busy = false;
    buyBtns.forEach(function (b) {
      b.disabled = false;
      var l = b.getAttribute('data-label');
      if (l && b.textContent !== l) b.textContent = l;
    });
  }
  function lockBuys(active) {
    busy = true;
    buyBtns.forEach(function (b) {
      b.disabled = true;
      if (b === active) b.textContent = 'Preparing your upgrade…';
    });
  }
  /* The back/forward restore. Also on a plain re-show (tab switch back) as a
     backstop, because a browser that skipped bfcache but kept the DOM — an
     iOS in-app webview returning from a payment sheet, say — reaches us here
     and nowhere else. Never fires while a request is genuinely in flight:
     inflight is cleared before any navigation, and a restored page has none. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted || busy) releaseBuys();
  });

  /* Retry the transient stuff. 429 and 5xx only — a 422 is Shopify telling us
     the line is wrong (sold out, bad variant) and repeating it just wastes the
     customer's time. Cart writes here are safe to repeat: clear is idempotent,
     and add only ever follows a clear that succeeded. */
  function cartFetch(path, opts, tries) {
    tries = tries || 0;
    return fetch(rootUrl + path, opts).then(function (r) {
      if ((r.status === 429 || r.status >= 500) && tries < 3) {
        return new Promise(function (res) { setTimeout(res, 400 * Math.pow(2, tries)); })
          .then(function () { return cartFetch(path, opts, tries + 1); });
      }
      return r;
    });
  }

  buyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (sublock) return; /* belt and braces */
      if (busy) return;    /* a kit is already on its way to checkout */
      var plan = parseInt(btn.getAttribute('data-target-plan'), 10);
      var qty = parseInt(btn.getAttribute('data-target-qty'), 10);
      if (!plan || !qty) return;
      lockBuys(btn);
      var items = [{ id: parseInt(root.getAttribute('data-dp'), 10), quantity: qty, selling_plan: plan }];
      var tin = parseInt(root.getAttribute('data-tin'), 10);
      if (tin) items.push({ id: tin, quantity: 1 });
      /* Free gift product (UI + wiring shipped ahead of the products
         themselves — the setting stays blank until they exist in Shopify,
         and a blank setting adds nothing). Gift products must be $0 like
         the tin; the page never does price maths. */
      /* Every gift up to this kit's rung. Blank entries survive as empty
         strings when a setting is unset, so filter before adding. */
      (btn.getAttribute('data-gift-variants') || '').split(',').forEach(function (raw) {
        var gid = parseInt(raw, 10);
        if (gid) items.push({ id: gid, quantity: 1 });
      });
      /* The mystery 13th pouch: one-time line, no selling plan. The
         "13th Pouch Free" automatic discount (buy 12 on subscription,
         get 1 free) zeroes it at checkout, and because it's one-time it
         never lands on the contract — the gift doesn't recur. */
      /* The mystery gift is its own product now (Aaron, 21 Aug), not a raw
         13th pouch. Two reasons: the old way needed the legacy "13th Pouch
         Free" discount, which competed with this kit's own gift discount for
         the same twelve pouches and won only one of them; and a discount whose
         free item is the pouch itself will zero POUCH lines in any cart of
         twelve, gifts or not. A distinct variant can only ever arrive here. */
      var mystery = parseInt(btn.getAttribute('data-mystery-variant'), 10);
      var bonus = parseInt(btn.getAttribute('data-bonus-qty'), 10);
      if (mystery) {
        items.push({ id: mystery, quantity: bonus || 1 });
      } else if (bonus) {
        items.push({ id: parseInt(root.getAttribute('data-dp'), 10), quantity: bonus });
      }
      cartFetch('/cart/clear.js', { method: 'POST' })
        .then(function (r) {
          /* Was unchecked. A rate-limited clear used to fall straight through
             to the add, which then piled this kit on top of whatever was
             already in the cart. */
          if (!r.ok) throw { step: 'clear', status: r.status };
          return cartFetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(
            function (e) { throw { step: 'add', status: r.status, why: e && (e.description || e.message) }; },
            function () { throw { step: 'add', status: r.status }; });
          return r.json();
        })
        .then(function () {
          /* Attribution, plus the 13th-pouch ledger stamp on a 12-month cart:
             Loop copies order attributes onto the subscription, so flow 22664
             sees `13th-pouch` present and does not add a second pouch on top
             of the one Shopify just zeroed. The value says what this door
             delivered (7 Sep): `upgrade-page-first-order` when the pouch is in
             the cart, `not-included-upgrade-page` while the pouch switch is
             off, so the record never claims a gift that was not given. Losing
             this must not lose the sale, so it never throws -- the cost of a
             miss is one extra free pouch on the customer's NEXT order, not a
             lost order. The pre-7-Sep key is cleared in case the cart drawer
             already wrote it. */
          var attrs = {
            upsell_source: 'upgrade_page',
            upsell_from_tier: root.getAttribute('data-tier'),
            upsell_src: src,
            'pouch-13-gifted': ''
          };
          if (String(btn.getAttribute('data-target-qty')) === '12') {
            attrs['13th-pouch'] = mystery ? 'upgrade-page-first-order' : 'not-included-upgrade-page';
          }
          return cartFetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).catch(function () {});
        })
        .then(function () {
          track('upgrade_checkout', { offer: btn.getAttribute('data-target-qty') });
          /* Unlock before leaving. If the browser brings this page back from
             its cache, it comes back clickable; if the navigation itself is
             refused (an extension, an in-app webview), the customer is not
             left staring at a dead button either. */
          releaseBuys();
          window.location.href = rootUrl + '/checkout';
        })
        .catch(function (err) {
          releaseBuys();
          /* This used to fail silently as far as we were concerned. The store
             is measurably capable of 429ing a real click, and without this we
             would never know how often the upgrade button simply does not
             work. */
          track('upgrade_checkout_error', {
            offer: btn.getAttribute('data-target-qty'),
            step: (err && err.step) || 'unknown',
            status: (err && err.status) || 0
          });
          alert('Something went wrong adding your kit — please try again.');
        });
    });
  });

  /* ---- Gift orbit ----
     Was a five-slot machine: one class per position, an 800ms CSS transition,
     a 4s step, and a swipe that only decided "next" or "previous". Nothing was
     ever between two states. Aaron, 23 Aug: make it orbit continuously like the
     photo rail on /pages/reviews, scrubbable by hand, returning to its own
     motion when the hand lets go.

     Same engine as sections/zph-photo-rail.liquid, and deliberately so: ONE
     scalar advanced every frame, dragged directly, carrying a flick that decays
     until the constant drift takes over again from wherever it landed. Nothing
     snaps back to a slot.

     What differs is that the rail translates a strip while this reads every
     transform off the same scalar. Each card gets its signed, wrapped distance
     `d` from centre, and d drives everything: x, the vertical dip, scale,
     z-order, the grey wash, the caption and the fade. So the centremost card
     is always the biggest, highest, sharpest one without anything having to
     decide that it is "the" active card — there is no active index any more,
     which is why the dots went.

     Spacing is EDGE-uniform, and it took two goes to get there. A circle
     (x = R·sin) spaced the centres unevenly by construction. Making x linear in
     d fixed the centres — measured gaps identical to a tenth of a pixel — and
     still looked wrong, because a card's WIDTH is a function of the same d: the
     two big cards in the middle left a 33px gap while the small outer pair left
     70px, so the rhythm compressed toward the centre and read as the cards
     slowing down and speeding up (Aaron, 23 Aug, and he is right — equidistant
     centres are not equidistant to the eye when the boxes are different sizes).

     So place them by the gap instead: dx/dd = width(d) + gap, which integrates
     to x(d) = W · F(|d|) · sign(d), F sampled once into a table. Nothing about
     that depends on the viewport — F is in units of card widths — so the same
     table serves every breakpoint and only W changes.

     Only the front layer is drawn (Aaron, same message). Cards fade out as
     they pass EDGE and are gone before they would have to travel back through
     the middle, so the wrap has nothing to hide and no card is ever seen
     sliding backwards behind the front row. Everything else — scale, dip,
     z-order — rides a cosine over that same visible span, which keeps the
     centre the apex without reintroducing the circle's spacing. */
  (function () {
    var car = root.querySelector('[data-car]');
    if (!car) return;
    var cards = [].slice.call(car.querySelectorAll('[data-car-card]'));
    var N = cards.length;
    if (!N) return;

    var SECS = parseFloat(car.getAttribute('data-orbit-secs')) || 5;   /* seconds per card */
    var DRIFT = 1 / (SECS * 1000);                                     /* cards per ms */
    var MAX_S = 1.08, MIN_S = 0.62;
    var EDGE = 1.75;              /* cards from centre at which a card is gone */
    var RETURN_MS = 900;          /* how long a hand-off back to the drift takes */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var pos = 0, vel = 0, painted = null;
    var dragging = false, lastX = 0, lastT = 0, moved = 0;
    var raf = null, prevT = 0, live = true, focus = -1;
    var returning = false, retT = 0, retV0 = 0;

    /* cubic-bezier(.16, 1, .3, 1) — the same shape a CSS ease-out expo has.
       Aaron, 23 Aug: a hand-off should be a curve, not a cut. The old version
       decayed the flick geometrically and then simply started adding the drift
       instead, which reads as a jerk when the flick was backwards: the velocity
       passes through zero and the ring flips direction in one frame. */
    function bez(u) {
      var x1 = 0.16, y1 = 1, x2 = 0.3, y2 = 1;
      if (u <= 0) return 0;
      if (u >= 1) return 1;
      var t = u, i, x, dx;
      for (i = 0; i < 6; i++) {                       /* Newton, then give up */
        x = 3 * (1 - t) * (1 - t) * t * x1 + 3 * (1 - t) * t * t * x2 + t * t * t - u;
        dx = 3 * (1 - t) * (1 - t) * x1 + 6 * (1 - t) * t * (x2 - x1) + 3 * t * t * (1 - x2);
        if (Math.abs(dx) < 1e-6) break;
        if (Math.abs(x) < 1e-5) break;
        t -= x / dx;
        if (t < 0) t = 0; else if (t > 1) t = 1;
      }
      return 3 * (1 - t) * (1 - t) * t * y1 + 3 * (1 - t) * t * t * y2 + t * t * t;
    }
    /* Area under (1 - ease) — how much of a head start actually gets spent
       before the curve has handed everything back to the drift. Sampled once so
       a click can be given the launch velocity that lands it exactly on the
       card asked for, rather than a guess that overshoots. */
    var SPEND = (function () {
      var a = 0, n = 240;
      for (var i = 0; i < n; i++) a += (1 - bez((i + 0.5) / n)) / n;
      return a;
    })();

    /* One card of travel in pixels. Measured every paint rather than cached:
       the card width is a clamp() on viewport units, so it changes under a
       resize and a stale pitch would make a drag scrub at the wrong rate. */
    /* offsetWidth, NOT getBoundingClientRect().width: the rect is measured
       AFTER the card's own scale, and cards[0] is being scaled by this very
       function's output. Reading it back made the spacing breathe between 0.62x
       and 1.08x as card 0 came round, so the whole rail expanded and contracted
       once per revolution. Layout width is the stable number. */
    function cardW() { return cards[0].offsetWidth || 180; }
    function gapFrac() { return parseFloat(getComputedStyle(car).getPropertyValue('--zc-gap')) || 0.12; }
    function wrap(d) { d = ((d % N) + N) % N; return d > N / 2 ? d - N : d; }

    /* scale at a distance — the one place the shape of the depth is defined. */
    function depthT(ad) { return ad >= EDGE ? 0 : Math.cos(Math.PI * ad / (2 * EDGE)); }
    function scaleAt(ad) { return MIN_S + (MAX_S - MIN_S) * Math.pow(depthT(ad), 1.6); }

    /* F(u) = ∫₀ᵘ (scale(v) + s''(v)/12 + gap) dv, in card widths.
       The constraint is not "the integral of the width", it is "the gap between
       two cards exactly one apart is always G" — and those are not the same
       thing while scale is curved. Integrating the width alone left the gap
       varying 31–44px on desktop where it should have been a flat 33 (measured
       on the draft), because ∫ over a span differs from the average of its two
       endpoints by −s''/12. That is the Euler–Maclaurin term, so add it back
       and the pair constraint holds for anything close to quadratic.

       s'' is clamped because the curve has an integrable spike where it meets
       EDGE (scale is C1 there but not C2). Cards out there are at zero opacity,
       so the correction is worth nothing and an unclamped spike would bend the
       spacing of the cards that ARE visible. */
    var FS = null, FSTEP = EDGE / 240, FGAP = null;
    function buildF() {
      var g = gapFrac();
      var h = FSTEP;
      function integrand(v) {
        var d2 = (scaleAt(v + h) - 2 * scaleAt(v) + scaleAt(Math.max(0, v - h))) / (h * h);
        var corr = d2 / 12;
        if (corr > 0.05) corr = 0.05; else if (corr < -0.05) corr = -0.05;
        return scaleAt(v) + corr + g;
      }
      FS = [0];
      for (var k = 1; k <= 240; k++) {
        var a = (k - 1) * FSTEP, b = k * FSTEP;
        FS.push(FS[k - 1] + (integrand(a) + integrand(b)) / 2 * FSTEP);
      }
      FGAP = g;
    }
    function F(u) {
      if (FS === null || gapFrac() !== FGAP) buildF();
      if (u >= EDGE) return FS[240] + (u - EDGE) * (MIN_S + FGAP);
      var f = u / FSTEP, k = Math.floor(f);
      return FS[k] + (FS[k + 1] - FS[k]) * (f - k);
    }
    /* Pixels that equal one card of travel, taken at the centre where the hand
       actually is. Used only to turn a drag into card-units. */
    function dragScale() { return cardW() * (MAX_S + gapFrac()); }

    function paint() {
      var W = cardW();
      var lift = (cards[0].offsetHeight || 240) * 0.13;   /* layout height, same reason */
      var near = -1, nearD = Infinity;
      for (var i = 0; i < N; i++) {
        var d = wrap(i - pos);
        var ad = Math.abs(d);
        /* t is 1 dead centre and 0 at EDGE — a quarter cosine over the visible
           span, so depth still eases rather than ramping linearly. */
        var t = depthT(ad);
        /* Curve the scale rather than reading it straight off depth. Linear in
           depth, the near pair came out only 15% smaller than the front card
           (measured 185px vs 156px at 390px) — the slot version separated them
           by 22%, and without that separation nothing looks like it is in
           front. The exponent restores the old contrast without reintroducing
           steps. */
        var s = scaleAt(ad);
        var x = (d < 0 ? -1 : 1) * W * F(ad);      /* constant gap, not constant pitch */
        var y = lift * (1 - t);                    /* dips away from centre */
        /* Hold full opacity across the front row and spend the fade on the
           outer half, so a card is not already ghostly while it is still one
           of the three being read. Zero before EDGE, so the wrap is invisible. */
        var o = Math.min(1, t * 1.5);
        var el = cards[i];
        el.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) scale(' + s.toFixed(3) + ')';
        el.style.zIndex = String(Math.round(t * 100));
        el.style.opacity = o.toFixed(3);
        el.style.pointerEvents = o < 0.05 ? 'none' : '';
        /* The grey wash and the caption fade are CSS, driven off this one
           number, so they stay continuous instead of flipping at a threshold. */
        el.style.setProperty('--zc-d', Math.abs(d).toFixed(3));
        if (Math.abs(d) < nearD) { nearD = Math.abs(d); near = i; }
      }
      /* One class survives, and only because two things genuinely are about a
         single card: the coral "Yours with this upgrade" badge, and what a
         screen reader should be told. */
      if (near !== focus) {
        if (focus > -1) cards[focus].classList.remove('is-focus');
        cards[near].classList.add('is-focus');
        focus = near;
      }
    }

    function frame(now) {
      var dt = Math.min(50, now - (prevT || now));
      prevT = now;
      if (!dragging) {
        if (returning) {
          /* Ease the velocity itself from whatever the hand left behind to the
             drift. Because it is the VELOCITY being eased and not a position,
             there is no target to snap to and the release cannot overshoot into
             a correction. */
          retT += dt;
          var u = Math.min(1, retT / RETURN_MS);
          var e = bez(u);
          vel = retV0 + (DRIFT - retV0) * e;
          pos += vel * dt;
          if (u >= 1) { returning = false; vel = DRIFT; }
        } else if (!reduce.matches) {
          pos += DRIFT * dt;
        }
      }
      pos = ((pos % N) + N) % N;
      if (pos !== painted) { paint(); painted = pos; }
      raf = live ? requestAnimationFrame(frame) : null;
    }
    function start() { if (!raf && live) { prevT = 0; raf = requestAnimationFrame(frame); } }

    /* A click is given the launch velocity whose eased hand-off covers exactly
       the distance asked for — same curve as a flick, so a pick and a swipe
       arrive the same way. Distance spent above the drift over the return is
       (v0 - DRIFT) * RETURN_MS * SPEND. */
    function impulse(cardsToTravel) {
      retV0 = DRIFT + cardsToTravel / (RETURN_MS * SPEND);
      retT = 0; returning = true;
    }

    car.addEventListener('pointerdown', function (e) {
      dragging = true; vel = 0; moved = 0;
      lastX = e.clientX; lastT = performance.now();
      car.classList.add('is-grabbing');
      try { car.setPointerCapture(e.pointerId); } catch (err) {}
    });
    car.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now();
      var dx = e.clientX - lastX, dt = (now - lastT) || 16;
      var dp = -dx / dragScale();                  /* drag right, ring turns back */
      pos += dp; moved += Math.abs(dx);
      vel = dp / dt;
      lastX = e.clientX; lastT = now;
      pos = ((pos % N) + N) % N;
      paint(); painted = pos;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      car.classList.remove('is-grabbing');
      retV0 = vel; retT = 0; returning = true;     /* curve back, never cut */
    }
    car.addEventListener('pointerup', endDrag);
    car.addEventListener('pointercancel', endDrag);
    car.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Click a tile to bring it round. Resolved by geometry, not by a listener
       per card: the cards carry a `filter`, which drops them out of hit-testing
       inside the track, so elementFromPoint at a side tile returns the track.
       Nearest centre to the pointer wins. */
    car.addEventListener('click', function (e) {
      if (moved > 8) { moved = 0; return; }        /* that was a scrub, not a pick */
      var best = -1, bestD = Infinity;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        var d = Math.abs((r.left + r.right) / 2 - e.clientX);
        if (d < bestD) { bestD = d; best = i; }
      });
      if (best > -1) impulse(wrap(best - pos));
    });
    /* The arrows are gone, so this is the only step-sized control left. */
    car.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); impulse(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); impulse(1); }
    });

    /* Do not burn a frame on a carousel nobody is looking at. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        live = es[0].isIntersecting && !document.hidden;
        if (live) start(); else if (raf) { cancelAnimationFrame(raf); raf = null; }
      }, { threshold: 0.2 }).observe(car);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { live = false; if (raf) { cancelAnimationFrame(raf); raf = null; } }
      else { live = true; start(); }
    });
    window.addEventListener('resize', function () { FS = null; paint(); painted = pos; }, { passive: true });

    /* Open with the recommended rung's gift at the front. It drifts off within
       a few seconds now, which Aaron accepted (23 Aug) — it still decides what
       the first glance lands on. First match wins, so the 12-month's two gifts
       resolve to the sunglasses. */
    var offer = root.getAttribute('data-offer');
    if (offer) {
      for (var k = 0; k < N; k++) {
        if (cards[k].getAttribute('data-gift-tile') === offer) { pos = k; break; }
      }
    }
    paint(); painted = pos;
    start();
  })();

  /* ---- Reveal on entry ----
     Ported from the reviews hero's approach (Aaron, 21 Aug) but entry only —
     nothing animates back out, so a reader scrolling up never sees the page
     dismantle itself.

     Targets are collected here rather than tagged in the markup, so the
     Liquid stays about content. The hidden class is added by this script:
     if it never runs, the page renders exactly as before instead of a column
     of invisible sections.

     Cards keep being observed rather than revealed immediately because
     data-show can leave one display:none at load — IntersectionObserver
     simply reports it when it finally has a box. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    /* The hero headline and subline don't fade — they wipe up out of a mask,
       one row at a time, the way the reviews hero does. --i is numbered here
       rather than in the Liquid so the count runs continuously from the last
       headline line into the subline, however many lines the copy breaks to.

       These play on load rather than on intersection: the subline sits right on
       the fold at common desktop heights, so an observer leaves it parked below
       its mask until the reader scrolls, and a hero that arrives only if you
       scroll is not a hero.

       zupg-armed is in the MARKUP, not added here, and that is deliberate.
       This script is an inline one deep in the section, so it is blocked on the
       stylesheets ahead of it and was measured running 143ms after first paint —
       arming from JS therefore showed the headline in place and then dropped it
       to wipe back in. The stylesheet carries a failsafe that unparks the rows
       a couple of seconds in, so a script that never runs costs a wipe, not a
       headline. */
    var heads = root.querySelectorAll('.zupg-head.zupg-armed');
    var rises = root.querySelectorAll('.zupg-banner .zupg-rise, .zupg-hero .zupg-rise');
    Array.prototype.forEach.call(rises, function (el, i) {
      el.style.setProperty('--i', i);
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(heads, function (el) { el.classList.add('is-in'); });
      });
    });

    var groups = [
      root.querySelectorAll('.zupg-banner'),
      root.querySelectorAll('.zupg-hero > *'),
      root.querySelectorAll('.zupg-found, .zupg-order'),
      root.querySelectorAll('.zupg-gifts-kicker, .zupg-gifts-h, .zupg-car'),
      root.querySelectorAll('.zupg-card'),
      root.querySelectorAll('.zupg-sublock-cta, .zupg-panel > h2, .zupg-panel > p')
    ];
    groups.forEach(function (list) {
      Array.prototype.forEach.call(list, function (el, i) {
        /* A masked head owns its own entry; fading it as well would double up. */
        if (el.classList.contains('zupg-head')) return;
        el.classList.add('zupg-reveal');
        /* Stagger inside a group only. 70ms is enough to read as a sequence
           without the last card feeling late. */
        if (i) el.style.transitionDelay = Math.min(i * 70, 280) + 'ms';
        io.observe(el);
      });
    });
  })();

  /* ---- Gift popovers: tap a thumbnail, learn what the gift is ---- */
  (function () {
    var pop = root.querySelector('[data-gm-pop]');
    if (!pop) return;
    var img = pop.querySelector('[data-gm-pop-img]'),
        nameEl = pop.querySelector('[data-gm-pop-name]'),
        rungEl = pop.querySelector('[data-gm-pop-rung]'),
        descEl = pop.querySelector('[data-gm-pop-desc]'),
        openBtn = null;
    var openedAt = 0;
    function close() { pop.classList.remove('is-open'); openBtn = null; }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.zupg-gm');
      if (btn && root.contains(btn)) {
        if (openBtn === btn) { close(); return; } /* second tap toggles off */
        openBtn = btn;
        /* The travel tin's tile can fall back to the inline emblem when no
           artwork is set, and then there is no <img> to read a src off — the
           old line threw on null and took the whole click handler with it.
           data-gm-img is authoritative when present; the thumbnail is the
           fallback; neither is not fatal. */
        var src = btn.getAttribute('data-gm-img') || (btn.querySelector('img') || {}).src || '';
        img.src = src;
        /* Hide the whole tile, not just the image: an empty 96px square reads
           as a picture that failed to load. */
        if (img.parentNode) img.parentNode.style.display = src ? '' : 'none';
        nameEl.textContent = btn.getAttribute('data-gm-name') || '';
        rungEl.textContent = btn.getAttribute('data-gm-rung') || '';
        descEl.textContent = btn.getAttribute('data-gm-desc') || '';
        pop.classList.add('is-open');
        openedAt = Date.now();
        if (window.matchMedia('(max-width: 560px)').matches) {
          pop.classList.add('is-center');
        } else {
          pop.classList.remove('is-center');
          var r = btn.getBoundingClientRect(), pw = pop.offsetWidth, phh = pop.offsetHeight;
          var x = Math.min(Math.max(r.left + r.width / 2 - pw / 2, 12), window.innerWidth - pw - 12);
          var y = r.top - phh - 12;
          if (y < 12) y = r.bottom + 12; /* no headroom: flip below the thumb */
          pop.style.left = x + 'px';
          pop.style.top = y + 'px';
        }
        return;
      }
      if (!e.target.closest('[data-gm-pop]')) close();
    });
    pop.querySelector('[data-gm-pop-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    /* Anchored to a fixed point, so a scroll detaches it and it has to close.
       But on touch the tap that OPENS it usually carries a little momentum,
       and that inertia scroll arrived a frame later and shut the popover on
       the same gesture that opened it — it flashed and vanished. Ignore
       scrolls in the first 350ms so the opening gesture cannot close it. */
    window.addEventListener('scroll', function () {
      if (Date.now() - openedAt < 350) return;
      close();
    }, { passive: true });
    window.addEventListener('resize', close);
  })();

  /* querySelectorAll, not querySelector: the portal link is rendered inside
     every card now, and only the offered card is ever on screen. Binding the
     first match would have wired the tracking to a hidden one. */
  root.querySelectorAll('[data-portal-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      /* Arms the portal's win-back bounce. It used to be armed by the
         auto-forward; with that off, the click IS the moment we send someone
         to the portal, so a cancelled subscriber who lands on an empty one
         still gets returned here with checkout unlocked. */
      try { sessionStorage.setItem('zupg_fwd', '1'); } catch (e) {}
      track('upgrade_swap', { offer: root.getAttribute('data-offer') });
    });
  });

  /* Login round-trip resilience: Shopify's hosted login may or may not return
     the customer to this page (return_to is stripped from the first redirect).
     Login opens in a new tab (fallback link) or the in-page sheet; THIS tab
     probes its own HTML for a logged-in render and reloads into the detected
     state the moment the session exists. */
  var probeTimer = null, probeUntil = 0, probing = false, lastProbe = 0;
  function probeSession() {
    if (root.getAttribute('data-tier') !== 'anon') return;
    /* Both guards were missing. probeUntil is set once and never cleared, so
       the visibilitychange handler below kept firing long after the interval
       had given up — and each probe re-downloads this page, which is ~440KB.
       A tab left open on the gate state was re-fetching it on every focus,
       for the life of the tab. The in-flight flag stops a fast focus/blur
       from stacking several of those on top of each other. */
    if (probing || Date.now() > probeUntil) return;
    /* Throttle. The visibilitychange hook below probes on every tab focus,
       which is what makes a sign-in in another tab feel instant — but each
       probe re-downloads this page, and someone alt-tabbing paid that cost
       every single time. 3s keeps the "instant" without the storm. */
    if (Date.now() - lastProbe < 3000) return;
    lastProbe = Date.now();
    probing = true;
    fetch(window.location.pathname + '?_probe=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { probing = false; return r.text(); })
      .then(function (t) {
        var m = t.match(/data-tier="([^"]+)"/);
        if (m && m[1] !== 'anon') {
          clearInterval(probeTimer); probeTimer = null;
          track('login_detected', { tier: m[1] });
          /* Every sign-in path funnels through this reload, so this is the one
             place that knows a sign-in just completed. The reloaded page reads
             the flag and takes them to their savings. */
          try { sessionStorage.setItem('zupg_justin', '1'); } catch (e) {}
          window.location.reload();
        }
      }).catch(function () { probing = false; });
  }
  function startProbing(showBanner, intervalMs) {
    probeUntil = Date.now() + 300000; /* give up after 5 min */
    if (showBanner) {
      var waiting = root.querySelector('[data-waiting]');
      if (waiting) waiting.hidden = false;
    }
    if (probeTimer) return;
    probeTimer = setInterval(function () {
      if (Date.now() > probeUntil) { clearInterval(probeTimer); probeTimer = null; return; }
      if (!document.hidden) probeSession(); /* only probe while they can see us */
    }, intervalMs || 15000);
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && probeUntil) probeSession();
  });
  var refreshBtn = root.querySelector('[data-refresh]');
  if (refreshBtn) refreshBtn.addEventListener('click', function () { window.location.reload(); });

  /* Two real buttons, one visible: Shopify's reskinned account trigger opens
     the sheet in-page (its own click handling — nothing forwarded, so it's
     guaranteed to work); the link is the fallback for stores/themes where
     the component never loads. whenDefined() waits indefinitely, so a slow
     network can't strand the page on the fallback. */
  /* Guarantee slideout. zph-home.js binds these controls only inside the PDP
     section, so on this page the panels would render and never open. Same
     class contract as the PDP (.open on the panel and the overlay), so the
     shared CSS and the global ESC / back-button handlers still apply.
     Queried from document, not root: the snippet renders outside .zph-upg. */
  (function () {
    var slides  = document.querySelectorAll('.zph-slide');
    var overlay = document.querySelector('[data-slide-overlay]');
    if (!slides.length) return;
    function closeSlides() {
      slides.forEach(function (s) { s.classList.remove('open'); });
      if (overlay) overlay.classList.remove('open');
    }
    document.querySelectorAll('[data-slide-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        closeSlides();
        var s = document.querySelector('.zph-slide[data-slide="' + b.dataset.slideOpen + '"]');
        if (!s) return;
        s.classList.add('open');
        if (overlay) overlay.classList.add('open');
        track('guarantee_open', { from: b.closest('[data-card]') ? b.closest('[data-card]').getAttribute('data-card') : 'unknown' });
      });
    });
    document.querySelectorAll('[data-slide-close]').forEach(function (b) {
      b.addEventListener('click', closeSlides);
    });
    if (overlay) overlay.addEventListener('click', closeSlides);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSlides(); });
  })();

  /* ---- Shopify's sign-in sheet leaves the page scroll-locked ----
     `shopify-account` (cdn.shopify.com/storefront/web-components/account.js)
     puts `overflow:hidden; touch-action:none` on <html> while its sheet is up,
     which is correct, and removes it again on Escape, a backdrop click and its
     own close button — but NOT when the dialog is closed programmatically,
     which is what happens the moment a sign-in completes. Measured on the draft
     23 Aug: after `dialog.close()` the dialog reports open=false and <html>
     keeps overflow:hidden and touch-action:none. Wheel and touch are dead from
     then on; only scripted scrolling still works, which is why our own
     post-sign-in scroll looked fine while the customer could not move the page
     (Aaron: "the scroll is broken on our page after signing in").

     Bisected to that file, not guessed: blocking account.js alone leaves the
     page unlocked, and the lock appears on /pages/upgrade — where the component
     is — but never on the homepage, where it is not.

     So: whenever the sheet is shut, put the page back. Only ever clears the two
     properties that stop a human scrolling, only while nothing that legitimately
     owns a lock is up, and never touches the theme's own lock (which uses the
     .zph-scrolllock class and pins the body, not inline styles on <html>). */
  (function () {
    var h = document.documentElement;
    function sheetOpen() {
      var a = document.querySelector('shopify-account');
      var d = a && a.shadowRoot && a.shadowRoot.querySelector('dialog');
      return !!(d && d.open);
    }
    function otherModal() {
      if (h.classList.contains('zph-scrolllock')) return true;
      var m = document.querySelectorAll('dialog[open], [aria-modal="true"]');
      for (var i = 0; i < m.length; i++) {
        var r = m[i].getBoundingClientRect();
        if (r.width > 1 && r.height > 1 && getComputedStyle(m[i]).visibility !== 'hidden') return true;
      }
      return false;
    }
    /* Shopify's privacy banner (dialog mode) locks BODY, not <html>, and owns
       that lock only while it is actually on screen. Same family of bug as the
       account sheet: dismissed oddly (or hidden by the preview bar), it can
       leave body overflow:hidden behind and the page dead to wheel and touch
       at mobile widths (Aaron, 1 Sep, /pages/upgrade). */
    function cookieBannerUp() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var r = b.getBoundingClientRect();
      return r.width > 1 && r.height > 1 &&
        getComputedStyle(b).display !== 'none' &&
        getComputedStyle(b).visibility !== 'hidden';
    }
    /* Each veto only covers the lock its owner actually set. The account sheet
       and dialog-style modals lock <html>; the cookie banner locks BODY and
       never touches <html>. Vetoing the <html> release on the banner stranded
       the sheet's lock behind something that did not own it: we auto-open the
       sheet 1.5s into a fresh anonymous landing, so a first-time visitor who
       dismissed the sheet while the banner was still up was left on a page
       with overflow:hidden and touch-action:none on <html> — dead to every
       finger gesture, though window.scrollTo still worked, which is why it
       never showed up in scripted checks (Aaron, 3 Sep, mobile). */
    function release() {
      var lockedHtml = h.style.overflow || h.style.touchAction;
      var lockedBody = document.body.style.overflow === 'hidden';
      if (!lockedHtml && !lockedBody) return;
      var modal = sheetOpen() || otherModal();
      var freed = false;
      if (lockedHtml && !modal) { h.style.overflow = ''; h.style.touchAction = ''; freed = true; }
      if (lockedBody && !modal && !cookieBannerUp()) { document.body.style.overflow = ''; freed = true; }
      if (freed) track('scroll_unlock', {});
    }
    /* The dialog closing does not touch <html>, so watching <html> alone would
       never fire. Watch the dialog's own `open` attribute, and keep a slow
       interval as the backstop for a sheet that is replaced rather than closed. */
    function watch() {
      var a = document.querySelector('shopify-account');
      var d = a && a.shadowRoot && a.shadowRoot.querySelector('dialog');
      if (!d || !window.MutationObserver) return false;
      new MutationObserver(release).observe(d, { attributes: true, attributeFilter: ['open'] });
      return true;
    }
    if (!watch()) {
      var tries = 0;
      var boot = setInterval(function () { if (watch() || ++tries > 40) clearInterval(boot); }, 250);
    }
    setInterval(release, 1000);
    window.addEventListener('pageshow', release);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) release(); });
  })();

  /* ---- Collapsible kit cards, phone only ----
     Below 920px the grid is one column, so three full cards is three
     screenfuls before a choice can be made (Aaron, 26 Aug). One card is open
     at a time; the rest show the .zupg-mh row and nothing else.

     Which one starts open: the rung the page already recommends
     (data-offer), because that is the answer the routing worked out. If the
     offer names a card that is not on screen — a hidden 12-month, a state
     with two cards — the last visible card wins, which is the best value on
     offer rather than the cheapest.

     The fold is applied by JS and never by Liquid, on purpose: with no JS,
     every card renders in full, which is the desktop page on a small screen —
     long, but complete and buyable. A CSS-only fold would leave a customer
     with a dead accordion and no prices.

     matchMedia rather than a resize handler, and it unfolds everything on the
     way back up to desktop — a card left folded at 1200px would be a card
     with no buy button. */
  (function () {
    var mq = window.matchMedia('(max-width:919.98px)');
    var cards = [].slice.call(root.querySelectorAll('.zupg-card'));
    if (!cards.length) return;

    function visible(c) { return c.offsetParent !== null || c.getClientRects().length > 0; }

    /* ---- The fold, animated ----
       The body is display:none'd rather than height-collapsed (see the CSS
       note), so there is nothing to transition — the card just jumps from one
       height to another. So measure both heights around the class swap and
       animate the CARD between them. FLIP, essentially: read, mutate, read,
       play the difference.

       overflow-clip-margin, not overflow:hidden. A folded card wears its
       "MOST POPULAR" badge on its top edge at -13px, and plain clipping
       decapitates it for the length of the animation. `clip` with a 26px
       margin contains the body without eating the badge; where the property
       is unsupported the declaration is dropped and the card simply does not
       clip, which is the old behaviour rather than a broken one.

       Reduced motion gets the jump. Someone who has asked the OS not to
       animate things has asked for this too. */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* The first fold happens on load, before anything has been looked at.
       Animating it means every phone opens the page with three cards visibly
       collapsing, which reads as a bug. */
    var settled = false;

    function fold(card) {
      var heights = cards.map(function (c) { return c.getBoundingClientRect().height; });
      cards.forEach(function (c) {
        var head = c.querySelector('[data-mobhead]');
        var isIt = c === card;
        c.classList.toggle('is-folded', !isIt);
        if (head) head.setAttribute('aria-expanded', String(isIt));
      });
      if (!settled || reduce.matches || !cards[0].animate) return;
      cards.forEach(function (c, i) {
        var to = c.getBoundingClientRect().height, from = heights[i];
        if (!from || !to || Math.abs(to - from) < 2) return;
        c.style.overflow = 'clip';
        c.style.overflowClipMargin = '26px';
        /* Timing and curve lifted from the product page's plan selector, which
           Aaron picked out: `.zph-expand{transition:max-height .4s ease}`.
           Not the technique — max-height animates against a fixed 520px cap,
           which clips anything taller and runs at the wrong speed for
           anything shorter. Measured heights give the same motion without
           either failure mode. */
        var a = c.animate(
          [{ height: from + 'px' }, { height: to + 'px' }],
          { duration: 400, easing: 'ease' }
        );
        a.onfinish = a.oncancel = function () { c.style.overflow = ''; c.style.overflowClipMargin = ''; };
      });
      /* The revealed body fades in behind the height so the card does not
         appear to grow around content that was already there. */
      if (settled && card && !reduce.matches) {
        card.classList.add('is-opening');
        setTimeout(function () { card.classList.remove('is-opening'); }, 440);
      }
    }
    function open(card) { fold(card); }

    function pick() {
      var offer = root.getAttribute('data-offer');
      var shown = cards.filter(visible);
      if (!shown.length) shown = cards;
      var byOffer = offer && shown.filter(function (c) { return c.getAttribute('data-card') === offer; })[0];
      return byOffer || shown[shown.length - 1];
    }

    function apply() {
      if (mq.matches) {
        open(pick());
      } else {
        cards.forEach(function (c) {
          c.classList.remove('is-folded');
          var head = c.querySelector('[data-mobhead]');
          if (head) head.setAttribute('aria-expanded', 'true');
        });
      }
    }

    /* ---- Keep the tapped card under the thumb ----
       Tapping a card below the open one collapses ~700px above it, so the
       card you just chose is yanked off the top of the screen and you land on
       its footer (Aaron, 26 Aug, with the screenshot). The old fix scrolled to
       the card's top after the swap, and it could not work: the fold animates
       height for 300ms, so a rect read on the first frame describes a layout
       that is still moving, and the smooth scroll then chased a stale target.

       This pins instead of chasing. Record the tapped head's distance from
       the top of the viewport, do the swap, and on every frame of the
       animation put it back where it was. The page rearranges around a
       fixed point: the thing you touched does not move, which is the whole
       of what Aaron asked for.

       Cost is one getBoundingClientRect and at most one scrollTo per frame
       for 380ms, and nothing at all when nothing is folding.

       scroll-behavior:smooth is set on <html> theme-wide, so a correction
       would otherwise animate and fight the next frame's correction. Turned
       off for the duration and restored after — not `behavior:'instant'`,
       which throws on browsers that predate the keyword. */
    function pin(anchor, mutate) {
      var root_el = document.documentElement;
      var prevBehavior = root_el.style.scrollBehavior;
      root_el.style.scrollBehavior = 'auto';
      var y = anchor.getBoundingClientRect().top;
      mutate();
      function correct() {
        var d = anchor.getBoundingClientRect().top - y;
        /* Sub-pixel drift is not worth a scroll write every frame. */
        if (d > 0.5 || d < -0.5) window.scrollTo(window.scrollX, window.scrollY + d);
      }
      correct();
      if (reduce.matches || !window.requestAnimationFrame) {
        root_el.style.scrollBehavior = prevBehavior;
        return;
      }
      var until = Date.now() + 480; /* the fold runs 400ms */
      (function frame() {
        correct();
        if (Date.now() < until) requestAnimationFrame(frame);
        else root_el.style.scrollBehavior = prevBehavior;
      })();
    }

    cards.forEach(function (c) {
      var head = c.querySelector('[data-mobhead]');
      if (!head) return;
      head.addEventListener('click', function () {
        if (!mq.matches || !c.classList.contains('is-folded')) return;
        pin(head, function () { open(c); });
        track('kit_expand', { card: c.getAttribute('data-card') || '' });
      });
    });

    apply();
    settled = true;
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  })();

  var acctNative = root.querySelector('[data-auth-native]');
  var authLink = root.querySelector('[data-auth-link]');
  if (acctNative && window.customElements) {
    customElements.whenDefined('shopify-account').then(function () {
      acctNative.hidden = false;
      if (authLink) authLink.style.display = 'none';
      acctNative.addEventListener('click', function () {
        track('login_click', { via: 'sheet' });
        startProbing(false, 6000); /* same tab: session appears fast, no banner */
      });
      /* Auto-open: only for a fresh anonymous landing (state=gate), only
         once, after a beat so the headline/offer paints first. Never while
         returning from Shop sign-in (shop_sign_in param): the session is
         being established client-side at that moment and the sheet must not
         open into the middle of the token exchange. */
      if (root.getAttribute('data-auto-open') === '1' && root.getAttribute('data-state') === 'gate' &&
          !qs.get('shop_sign_in') && !qs.get('shop_consented_scopes')) {
        var delay = parseFloat(root.getAttribute('data-auto-open-delay') || '1.5') * 1000;
        setTimeout(function () {
          if (root.getAttribute('data-state') !== 'gate') return;
          var inner = acctNative.shadowRoot && acctNative.shadowRoot.querySelector('button[aria-haspopup="dialog"]');
          if (inner) {
            track('login_click', { via: 'auto' });
            inner.click();
            startProbing(false, 6000);
          }
        }, delay);
      }
    });
  }
  if (authLink) authLink.addEventListener('click', function () {
    track('login_click', { via: 'code' });
    startProbing(true, 15000); /* new tab: default href/target navigate normally */
  });

  /* Returning from Shop sign-in (proven to land back here with shop_sign_in=true):
     the server rendered this page anonymous because the storefront session is
     still being established client-side. Watch for it and reload into the
     detected state as soon as it exists. */
  if (qs.get('shop_sign_in') && root.getAttribute('data-state') === 'gate') {
    startProbing(false, 4000);
  }

  var state = root.getAttribute('data-state');
  if (state === 'offer' || state === 'top' || state === 'done') setUnlocked();
  applyPath();
  track('view', { state: state });
})();
